





























































































































import { Component, Vue, Watch } from "vue-property-decorator"
import { mapGetters, mapState } from "vuex"
import { debounce, isEqual } from "lodash"
import { STATUSES } from "@/constants/risk_profile"

@Component({
  computed: {
    ...mapState({
      loading: "loading",
    }),
    ...mapState("RiskProfileTemplate", {
      riskProfileTree: "riskProfileTree",
    }),
    ...mapState("RiskProfile", {
      riskProfile: "riskProfile",
    }),
    ...mapGetters("RiskProfile", {
      enabledRiskProfileItems: "enabledRiskProfileItems",
    }),
    ...mapState("QuestionGroup", {
      questionGroup: "questionGroup",
    }),
  },
})
export default class QuestionGroupPreviewRiskProfile extends Vue {
  riskProfileTree!: Model[]
  enabledRiskProfileItems!: RiskProfileItem[]
  riskProfile!: Model
  questionGroup!: Model

  optionTickValues = [0.1, 0.2, 0.5, 0.8, 1.0]
  previewRiskProfiles = {
    items: [],
  }
  riskProfileTemplates = []
  searchForTemplate = ""
  searchForPreview = ""
  reload = 0
  snackbar = {
    show: false,
    message: "",
    color: "green",
  }
  selectedTemplate: Model | null = null
  selectedRiskProfile: Model | null = null
  localRiskProfile: Model | null = null

  debounceFetchForPreview!: () => void

  @Watch("searchForPreview")
  watchSearchForPreview() {
    this.debounceFetchForPreview()
  }

  get items() {
    if (this.riskProfileTree) {
      for (const section of this.riskProfileTree) {
        for (const sub_section of section.sub_sections) {
          sub_section.items.sort((a, b) => a.display_order - b.display_order)
        }
      }
    }

    return this.riskProfileTree || []
  }
  set items(value) {
    this.$store.commit("RiskProfileTemplate/SET_RISK_PROFILE_TREE", value)
  }

  get previewRiskProfilesItems() {
    return this.previewRiskProfiles.items
  }

  get isDirty() {
    if (!this.localRiskProfile) {
      return false
    }

    return (
      !isEqual(this.localRiskProfile, this.riskProfile) ||
      !isEqual(this.localRiskProfile.items, this.enabledRiskProfileItems)
    )
  }

  mounted() {
    this.debounceFetchForPreview = debounce(() => {
      this.searchForPreview &&
        this.searchForPreview != this.localRiskProfile?.name &&
        this.searchPreviews()
    }, 500)

    this.searchTemplates()

    this.searchPreviews()
  }

  async searchTemplates() {
    this.riskProfileTemplates = await this.$store.dispatch(
      "RiskProfileTemplate/fetchList",
      {
        params: {
          search_name: this.searchForTemplate,
          per_page: 50,
        },
      }
    )
  }

  async searchPreviews() {
    this.previewRiskProfiles = await this.$store.dispatch(
      "RiskProfile/fetchList",
      {
        params: {
          search_name: this.searchForPreview,
          is_for_preview: 1,
          per_page: 50,
        },
      }
    )
  }

  async fetchRiskProfileTemplate() {
    if (!this.selectedTemplate) {
      return
    }
    await this.$store.dispatch(
      "RiskProfileTemplate/fetchFullRiskProfileTemplate",
      this.selectedTemplate.object_id
    )

    this.localRiskProfile = {
      name: this.selectedTemplate.name,
      description: "Risk Profile Preview",
      items: [],
    }

    this.selectedRiskProfile = null
    this.selectedTemplate = null
  }

  async fetchRiskProfilesForPreview() {
    if (!this.selectedRiskProfile) {
      return
    }
    await this.$store.dispatch("RiskProfile/fetch", {
      object_id: this.selectedRiskProfile.object_id,
      params: {
        expand: ["items"],
      },
    })

    this.selectedRiskProfile = null
    this.selectedTemplate = null
    this.localRiskProfile = this.riskProfile
  }

  createNew() {
    this.$store
      .dispatch("RiskProfileSection/fetchFullStructure")
      .then((response) => {
        this.$store.commit(
          "RiskProfileTemplate/SET_RISK_PROFILE_TREE",
          response.data.data
        )
      })

    this.localRiskProfile = {
      name: "",
      description: "Risk Profile Preview" + this.questionGroup.name,
      items: [],
    }
  }

  async saveAsPreview() {
    await this.$store
      .dispatch("RiskProfile/createForPreview", {
        name: this.localRiskProfile?.name,
        custom_job_role_name: this.localRiskProfile?.name,
        description: this.localRiskProfile?.description,
        risk_profile_items: this.enabledRiskProfileItems,
      })
      .then((response) => {
        // show success message
        this.showSnackbar({
          show: true,
          message: "Saved",
          success: true,
        })
        this.localRiskProfile = response.data.data
        return response
      })
      .catch(({ response }) => {
        if (response) {
          // show error message
          let message = ""
          for (const key in response.data.error) {
            message += `${response.data.error[key]}<br />`
          }

          this.showSnackbar({
            show: true,
            message,
            success: false,
          })
        }
      })

    // reload risk profile dropdown list
    this.searchForPreview = ""
    await this.searchPreviews()
  }

  async updatePreview() {
    await this.$store
      .dispatch("RiskProfile/updateForPreview", {
        object_id: this.localRiskProfile?.object_id,
        name: this.localRiskProfile?.name,
        custom_job_role_name: this.localRiskProfile?.name,
        description: this.localRiskProfile?.description,
        risk_profile_items: this.enabledRiskProfileItems,
        status: STATUSES.STATUS_PUBLISHED.key,
      })
      .then((response) => {
        // show success message
        this.showSnackbar({
          show: true,
          message: "Saved",
          success: true,
        })
        return response
      })
      .catch(({ response }) => {
        if (response) {
          // show error message
          let message = ""
          for (const key in response.data.error) {
            message += `${response.data.error[key]}<br />`
          }

          this.showSnackbar({
            show: true,
            message,
            success: false,
          })
        }
      })

    // reload risk profile dropdown list
    this.searchForPreview = ""
    await this.searchPreviews()
  }

  async deleteRiskProfile() {
    await this.$store.dispatch(
      "RiskProfile/deleteForPreview",
      this.selectedRiskProfile?.object_id
    )

    // if the deleted risk profile is same as local editing risk profile, clean up the local risk profile
    if (
      this.selectedRiskProfile?.object_id === this.localRiskProfile?.object_id
    ) {
      this.localRiskProfile = null
    }

    this.searchForPreview = ""
    await this.searchPreviews()
    this.reload++
  }

  mapItemText(item) {
    if (!item) {
      return ""
    }
    return item.name + " " + item.created_at
  }

  showSnackbar({ show, message, success }) {
    this.snackbar.show = show
    this.snackbar.message = message
    this.snackbar.color = success ? "green" : "red darken-1"
  }
}
